import { render } from "./NormalComponent.vue?vue&type=template&id=ab7709b4"
import script from "./NormalComponent.vue?vue&type=script&lang=js"
export * from "./NormalComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__